export const CRM_LICENSES = [
  'CRM_MACROS_FEATURE',
  'CRM_BASE_FEATURE',
  'CUSTOM_DATABASE',
];
